import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import stamp from '../../../../../Images/stamp.jpg';
import moment from "moment";



export const GenerateLOE = (response) => {
    console.log(response, "ooooooooooooooooooooo")
    const doc = new jsPDF("portrait", "pt", "A4");
    doc.setFont("Source Serif 4", "normal");
    const PAGE_HEIGHT = doc.internal.pageSize.height;
    let currentY = 40;

    // ----------------------------------------------------------
    // ✅ Helper: Move to next page when needed
    // ----------------------------------------------------------
    const ensurePageSpace = (neededSpace = 20) => {
        if (currentY + neededSpace > PAGE_HEIGHT - 40) {
            doc.addPage();
            currentY = 40;
        }
    };

    // ----------------------------------------------------------
    // ✅ Helper: Write normal text
    // ----------------------------------------------------------
    const writeText = (text, x = 60, maxWidth = 480, lineHeight = 15) => {
        const lines = doc.splitTextToSize(text, maxWidth);
        doc.setFont("Source Serif 4", "normal");
        lines.forEach((line) => {
            ensurePageSpace(lineHeight);
            doc.text(line, x, currentY);
            currentY += lineHeight;
        });
        currentY += 5;
    };

    // ----------------------------------------------------------
    // ✅ Helper: Write Heading
    // ----------------------------------------------------------
    const writeHeading = (text, x = 50) => {
        ensurePageSpace(20);
        doc.setFont("Source Serif 4", "bold");
        doc.setFontSize(11);
        doc.text(text, x, currentY);
        currentY += 20;
        doc.setFont("Source Serif 4", "normal");
        doc.setFontSize(10.5);
    };

    const writeHeading2 = (text, x = 60) => {
        ensurePageSpace(20);
        doc.setFont("Source Serif 4", "bold");
        doc.setFontSize(11);
        doc.text(text, x, currentY);
        currentY += 20;
        doc.setFont("Source Serif 4", "normal");
        doc.setFontSize(10.5);
    };

    // ----------------------------------------------------------
    // ✅ Helper: Bullet list
    // ----------------------------------------------------------
    const writeBullets = (items) => {
        doc.setFontSize(9.5);
        items.forEach((item) => {
            ensurePageSpace(20);
            doc.circle(80, currentY - 4, 2, "F");
            doc.text(doc.splitTextToSize(item, 420), 90, currentY);
            currentY += 15;
        });
        currentY += 10;
    };

    // ----------------------------------------------------------
    // ✅ LOGO (optional)
    // ----------------------------------------------------------
    // const logoImg = logo;
    // if (logoImg) doc.addImage(logo, "PNG", 40, 20, 120, 45);

    // ----------------------------------------------------------
    // ✅ RIGHT BLOCK
    // ----------------------------------------------------------
    doc.setFont("Source Serif 4", "bold");
    doc.setFontSize(11.5);
    doc.text("Leaderly Auditors & Consultants", 380, 42);
    doc.text("Al Aqeel Al Mutameyza S.P.C", 380, 58);

    doc.setFont("Source Serif 4", "normal");
    doc.setFontSize(10.5);

    const rightText = [
        "Al Mouj",
        "P.O. Box 260",
        "Postal Code 138",
        "Sultanate of Oman",
        "T +968 24974887",
        "E-mail: info@Leaderly.com",
        "www.Leaderly.com",
        "Tax Card No. 1587032"
    ];

    let rightY = 78;
    rightText.forEach((line) => {
        doc.text(line, 380, rightY);
        rightY += 15;
    });

    // ----------------------------------------------------------
    // ✅ Address Block
    // ----------------------------------------------------------
    currentY = 260;
    writeText(`${response?.customerId?.ownerName || ''}`, 60, 480, 8);
    writeText(`${response?.customerId?.companyName || ''}`, 60, 480, 8);
    writeText(`${response?.customerId?.address || ''} \n\n`, 60, 480, 8);

    writeText(`${moment(response?.startDate).format('DD/MM/YYYY') || ''} \n`, 60);

    // ----------------------------------------------------------
    // ✅ Title
    // ----------------------------------------------------------
    writeHeading(`Letter of Engagement: ${response?.customerId?.companyName || ''} - ${response?.productId?.productName || ''}`);

    // ----------------------------------------------------------
    // ✅ Body Text (AutoTable)
    // ----------------------------------------------------------
    const bodyText =
        `Dear ${response?.customerId?.ownerName || ''}\n` +
        `We are pleased to confirm our engagement to aid with ${response?.productId?.productName || ''} for ${response?.customerId?.companyName || ''} \n` +
        "(the “Company” or “Client” or “you”). \n\n" +
        "The attached Engagement Agreement sets out the agreed services, related report(s) and other deliverables " +
        "that Leaderly Audit & Consultants, Oman (“Leaderly” or the “Firm” or “we”) will provide to the client.\n\n" +
        "In accordance with our normal procedures, we set out below our understanding of the basis on which " +
        "we are to act as tax consultants and the respective areas of responsibility of the company and ourselves.";

    autoTable(doc, {
        margin: { left: 60, right: 40 },
        startY: currentY,
        theme: "plain",
        styles: { fontSize: 10.5, overflow: "linebreak", cellPadding: 1.5, lineHeight: 1.4, font: 'Source Serif 4', fontStyle: 'normal', },
        body: [{ content: bodyText }],
    });

    currentY = doc.lastAutoTable.finalY + 25;

    // ----------------------------------------------------------
    // ✅ 1. Scope of Work
    // ----------------------------------------------------------
    writeHeading("1. Scope of work");
    writeText(
        "Leaderly will offer your business, access to specialists who will provide expert services and analyze business transactions undertaken by the Client."
    );

    // ----------------------------------------------------------
    // ✅ I. VAT Compliance
    // ----------------------------------------------------------
    writeHeading2("I. The key tasks for the Quarterly VAT Compliance Services include:");
    writeBullets([
        "Review of data prepared for VAT returns.",
        "Discuss the steps taken to reconcile management accounts and VAT Returns.",
        "Review of tax documents on a sample basis.",
        "Issuing report on errors found during the review of VAT Returns.",
        "Assistance in the calculation of Annual wash-ups, if applicable."
    ]);

    // ----------------------------------------------------------
    // ✅ II. ARI Section
    // ----------------------------------------------------------
    writeHeading2("II. The key tasks for the Filing of Annual Return of Income (ARI) include:");
    writeBullets([
        "Income Tax Computation for the year.",
        "Computation on Tax Depreciation.",
        "Deferred Tax Computation.",
        "Providing Tax Schedules for each item under ARI.",
        "Online filing of the ARI with all the relevant schedules.",
        "Providing the finalized submission copy of ARI."
    ]);

    // ----------------------------------------------------------
    // ✅ III. Withholding Tax
    // ----------------------------------------------------------
    writeHeading2("III. The key tasks for Withholding Tax include:");
    writeBullets([
        "Reviewing the invoices and foreign payments to identify withholding tax applicability.",
        "Prepare and file periodic withholding tax returns as required by the Tax Authorities.",
        "Ensuring timely submission of withholding tax returns within deadlines."
    ]);

    // ----------------------------------------------------------
    // ✅ Staff Assignment
    // ----------------------------------------------------------
    writeHeading("2. Staff assignment");
    writeText(
        "Our firm places great emphasis on ensuring that we provide the best possible services to ourclients by using a staff of a suitable level of experience concerning the complexity of the service performed. We will ensure the highest level of client service to you at all times. \n " +
        "With this objective in mind, a specific senior member of our staff will be assigned to your company who will have overall responsibility for the engagement and liaison and other continual relationships with the client management"
    );

    // ----------------------------------------------------------
    // ✅ 3. Basis of fees
    // ----------------------------------------------------------
    writeHeading("3. Basis of fees");
    writeText(
        "Our fees are based on the degree of responsibility and skill involved and the time necessarily occupied on the work. Based on our understanding of the activities of the Company are the proposed fee on the following page."
    );
    ensurePageSpace(100);
    autoTable(doc, {
        startY: currentY,
        margin: { left: 60, right: 40 },
        head: [["S.No", "Particulars", "Estimated Quantity", "QTY", "Amount (OMR)"]],
        body: [
            ["1", "VAT Quarterly Compliance (Q2 2025 - Q4 2026)", "Quarterly", "7", "300.000"],
            ["2", "ITR Filing FY 2025", "Quarterly", "1", "500.000"],
            ["3", "WHT (Jan 2026 - Dec 2027)", "Quarterly", "8", "1,750.000"],
        ],
        theme: "grid",
        headStyles: {
            fillColor: [51, 102, 204],
            halign: "center",
            valign: "middle"
        },
        styles: {
            fontSize: 10.5,
            cellPadding: 4,
            lineWidth: 0.2,
            font: "Source Serif 4",
            fontStyle: "normal",
            halign: "center",
            valign: "middle"
        }
    });
    currentY = doc.lastAutoTable.finalY + 20;
    writeText("The above fee is net of all applicable taxes, VAT, Withholding Taxes in Oman, Out-of-pocket expenses, travel costs in Oman, and disbursements. Any such tax or cost needs to be borne by the Company.");

    // ----------------------------------------------------------
    // ✅ 4. Payment Terms
    // ----------------------------------------------------------
    writeHeading("4. Payment Terms");
    writeText("The payment of our fee shall be in accordance with our Terms of Business and shall become payable in the following event:");

    ensurePageSpace(20);
    doc.setFont("Source Serif 4", "bold");
    doc.setFontSize(9.5);
    doc.text("Taxation Services:", 60, currentY);
    currentY += 20;
    doc.setFont("Source Serif 4", "normal");
    writeBullets([
        "100% on completion of the filing."
    ]);
    writeText(
        "The payment must be made within 7 days of receipt of our invoice. We reserve the right to withhold our signed Report until the final payment has been received. All payments associated with the Engagement are calculated net of tax and any bank charges that may be applicable."
    );

    // ----------------------------------------------------------
    // ✅ 5. Variation of Scope
    // ----------------------------------------------------------
    writeHeading("5. Variation of Scope");
    writeText(
        "Of course, circumstances may arise that require us to spend additional time performing the Services. Some of the circumstances that are beyond our control include inter alia, errors in your records, inability to obtain information from third parties, failure to furnish accurate and complete information to us on a timely basis, and unforeseen events, including but not limited to regulatory changes. If it appears that the estimated fee will be exceeded, we will consult with you so that you will have a better understanding of our fees before we continue. Please note that our fee is neither a maximum nor a fixed fee quotation, therefore, we will keep you informed of any circumstances that affect the Services’ scope, the timetable, or our level of participation."
    );

    // ----------------------------------------------------------
    // ✅ 6. Amendments to the Initial Contract
    // ----------------------------------------------------------
    writeHeading("6. Amendments to the Initial Contract");
    writeText(
        "During the Engagement, either Party may request additions, deletions, or modifications to the scope or nature of the Services (a “Change”). Leaderly will not be obligated to start Services on any Change until the fee and/or impact on the schedule is agreed on and a revised Engagement Agreement is issued and signed between the Parties for any new service."
    );

    // ----------------------------------------------------------
    // ✅ 7. Authorization
    // ----------------------------------------------------------
    writeHeading("7. Authorization");
    writeText(
        "Please confirm your acceptance of this Agreement and the Terms of Business by signing below and returning one copy to us. We appreciate the opportunity to work with the Company and assure you that the Engagement will be given our closest attention."
    );
    writeText(
        "Kindly confirm in writing your agreement to the terms of this letter, which will remain effective from one appointment to another until it is replaced, by signing the letter in the space provided below and returning a copy to us. If the contents are not in accordance with your understanding of the arrangements made, we shall be pleased to receive your observations and to give you any further information you require."
    );


    // ----------------------------------------------------------
    // ✅ Place Stamp
    // ----------------------------------------------------------
    doc.addImage(stamp, "JPG", 300, 170, 90, 80);

    // ✅ Ensure headings come BELOW the stamp
    if (currentY < 270) {
        currentY = 270;
    }

    // ----------------------------------------------------------
    // ✅ Final Headings
    // ----------------------------------------------------------
    writeHeading("Leaderly Auditors & Consultants");
    writeHeading("enclosure");
    writeHeading("The above-mentioned terms of engagement were agreed upon and approved");
    writeHeading(`${response?.customerId?.ownerName || ''}`);
    writeHeading(`${response?.customerId?.companyName || ''}`);

    // ----------------------------------------------------------
    // Signature + Date on same line
    // ----------------------------------------------------------

    currentY += 120;
    ensurePageSpace(40);
    doc.setFont("Source Serif 4", "normal");
    doc.setFontSize(11);
    doc.text("Signature ...............................", 60, currentY);
    const pageWidth = doc.internal.pageSize.getWidth();
    doc.text(`Date: ...............................`, pageWidth - 190, currentY);
    currentY += 30;


    // ----------------------------------------------------------
    // ✅ OUTPUT PDF
    // ----------------------------------------------------------
    doc.setProperties({ title: "Letter of Engagement" });
    const blob = doc.output("blob");
    window.open(URL.createObjectURL(blob));
};
